<template>
  <div class="container">
        关于我们
   
  </div>
</template>

<script>
export default {
  name: 'about',
  data() {
    return {
      
    }
  },
  methods: {
    
  },
}
</script>

<style scoped>
  .container {}
</style>
